import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  forwardRef,
} from "react";
import Container from "@mui/material/Container";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import { useForm } from "react-hook-form";
import { round, isNull, isEmpty, delay } from "lodash";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import InputAdornment from "@mui/material/InputAdornment";
import LoadingButton from "@mui/lab/LoadingButton";
import SyncIcon from "@mui/icons-material/Sync";
import Checkbox from "@mui/material/Checkbox";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useSelector, useDispatch } from "react-redux";
import {
  setGlobalLoader,
  showNotifier,
  setStoreDetails as setStoreDetailsAction,
  setCompletedOrderCount,
  setDataguideInProgress,
  setOrderTypeDetails,
  setFillInOrder,
} from "../../../store/globalSlice";
import { withSnackbar } from "../../../components/SnackbarHOC";
import {
  handleCommonError,
  MemberNoValidation,
  UPLOAD_STATUS,
  FILL_IN_ORDER_TYPE_ID,
} from "../../../utils";
import configData from "../../../config.js";
import TextFieldControl from "../../../components/Inputs/TextFieldControl";
import SelectControl from "../../../components/Inputs/SelectControl";
import CommonDialog from "../../../components/CommonDialog";
import StoreDialogContent from "../StoreDialogContent";
import ModelStoreDialogContent from "../ModelStoreDialogContent";
import FileUpload from "../../../components/FileUpload";
import FileDetailsTable from "../FileDetailsTable";
import ProjectStatus from "../DetailsProjectStatus";
import useRequest from "../../../hooks/useRequest";
import usePermissions from "../../../hooks/usePermissions";
import PermissionsGate from "../../../permissions/PermissionsGate";
import { SCOPES } from "../../../permissions/permissions-map";
import useStableCallback from "../../../hooks/useStableCallback";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={2} ref={ref} {...props} />;
});

const COMPLETED_STATUS_CODE = 4;

const SS_ORDER_TYPE = 6;

const numInputs = ["zipCode", "creditLimit"];

const DialogNoteSx = {
  fontSize: "14px",
  fontStyle: "italic",
  marginTop: "8px",
  color: "dimgrey",
};

const TemplateLinkSx = {
  float: "right",
  fontSize: "14px",
  lineHeight: "1.3em",
  fontWeight: 500,
};

const TemplateHyperLink = { color: "blue", cursor: "pointer" };

const FileSuccessTitleSx = { color: (theme) => theme.palette.success.main };

const FileUploadBoxNoteSx = {
  display: "inline-block",
  color: (theme) => theme.palette.grey[600],
};

function Details({ snackbarShowMessage }) {
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
    reset,
  } = useForm({
    mode: "all",
  });
  const dispatch = useDispatch();
  const { requestMaker } = useRequest();
  const { hasPermission } = usePermissions();
  const { promiseInProgress } = usePromiseTracker();
  const [fileUploading, setFileUploading] = useState({
    storeInv: false,
    dataguide: false,
    OSOItemList: false,
    SSItemList: false,
  });
  const [orderTypeIdCache, setOrderTypeIdCache] = useState(null);
  const [country, setCountry] = useState([]);
  const [dcNames, setDcNames] = useState([]);
  const [otNames, setOtNames] = useState([]);
  const [ptNames, setPtNames] = useState([]);
  const [planner, setPlanner] = useState([]);
  const [mac, setMac] = useState([]);
  const [projStatus, setProjStatus] = useState(0);
  const [pending, setPending] = useState(false);
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(0);
  const [archive, setArchive] = useState(false);
  const [details, setDetails] = useState({});
  const [firstError, setFirstError] = useState("");
  const [siSyncing, setSISyncing] = useState(false);
  const [phSyncing, setPHSyncing] = useState(false);
  // Store Inventory
  const [siFileDetails, setSIFileDetails] = useState([]);
  const [siFileData, setSIFileData] = useState([]);
  const [siFileName, setSIFileName] = useState("");
  const [showUploadedSIFile, setShowUploadedSIFile] = useState(false);
  const [showSIErrorFile, setShowSIErrorFile] = useState(false);
  const [uploadedSIFileLink, setUploadedSIFileLink] = useState("");
  const [errorSIFileLink, setErrorSIFileLink] = useState("");
  // DATAGUIDE
  const [dataguideDetails, setDataguideDetails] = useState([]);
  const [dataguideData, setDataguideData] = useState([]);
  // OSO Item List
  const [ilFileDetails, setILFileDetails] = useState([]);
  const [ilFileData, setILFileData] = useState([]);
  const [ilFileName, setILFileName] = useState("");
  const [showUploadedILFile, setShowUploadedILFile] = useState(false);
  const [showILErrorFile, setShowILErrorFile] = useState(false);
  const [uploadedILFileLink, setUploadedILFileLink] = useState("");
  const [errorILFileLink, setErrorILFileLink] = useState("");
  // SS Item List
  const [ssFileDetails, setSSFileDetails] = useState([]);
  const [ssFileData, setSSFileData] = useState([]);
  const [ssFileName, setSSFileName] = useState("");
  const [showUploadedSSFile, setShowUploadedSSFile] = useState(false);
  const [showSSErrorFile, setShowSSErrorFile] = useState(false);
  const [uploadedSSFileLink, setUploadedSSFileLink] = useState("");
  const [errorSSFileLink, setErrorSSFileLink] = useState("");

  const [storeDetails, setStoreDetails] = useState(null);
  const [modelStoreDetails, setModelStoreDetails] = useState(null);
  const [isCRMStore, setIsCRMStore] = useState(true);
  const [selectedStoreId, setSelectedStoreId] = useState(null);
  const [showStoreDialog, setShowStoreDialog] = useState(false);
  const [selectedStoreIndex, setSelectedStoreIndex] = useState(0);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorContent, setErrorContent] = useState("");
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showOrderTypeWarningDialog, setShowOrderTypeWarningDialog] =
    useState(false);
  const [showModelStoreWarningDialog, setShowModelStoreWarningDialog] =
    useState(false);
  const [showStoreSuppliesWarningDialog, setStoreSuppliesWarningDialog] =
    useState(false);
  const [confirmSave, setConfirmSave] = useState(true);
  const [otherHelperText, setOtherHelperText] = useState({
    country: "",
    distributionCenter: "",
    planner: "",
    mac: "",
  });
  const [initialModelStoreNumber, setInitialModelStoreNumber] = useState(null);
  const [initialModelStoreId, setInitialModelStoreId] = useState(null);
  const [cloneStatus, setCloneStatus] = useState(false);
  const [blockSSOrderType, setSSBlockOrderType] = useState(false);
  const [blockOrderType, setBlockOrderType] = useState(false);
  const [purchaseHistory, setPurchaseHistory] = useState(false);
  const [storeInventory, setStoreInventory] = useState(false);
  const [typeSelected, setTypeSelected] = useState("");
  const [showSIPHDialog, setShowSIPHDialog] = useState(false);
  const memberNumberValueWatcher = watch("memberNumber", "");
  const modelStoreValueWatcher = watch("modelStoreId", "");
  const creditLimitValueWatcher = watch("creditLimit", "");
  const orderTypeValueWatcher = watch("orderTypeId", "");
  const store = useSelector((store) => store.global.store);
  const user = useSelector((store) => store.global.user);

  const canEditPermission = useMemo(
    () => hasPermission({ scopes: [SCOPES.canEdit] }),
    [hasPermission]
  );

  const isProjectArchived = useMemo(() => store?.isArchived, [store]);

  useEffect(() => {
    if (modelStoreValueWatcher === initialModelStoreNumber) {
      setSelectedStoreId(initialModelStoreId);
    } else {
      setSelectedStoreId(null);
    }
  }, [modelStoreValueWatcher, initialModelStoreId, initialModelStoreNumber]);

  useEffect(() => {
    if (orderTypeValueWatcher === FILL_IN_ORDER_TYPE_ID) {
      setValue("modelStoreId", "");
    }
  }, [orderTypeValueWatcher, setValue]);

  useEffect(() => {
    const firstError = Object.keys(errors)?.reduce((field, a) => {
      return !!errors[field] ? field : a;
    }, null);
    if (firstError) {
      setFirstError(firstError);
    }
  }, [errors, setFirstError]);

  useEffect(() => {
    setShowSIErrorFile(false);
  }, [siFileData]);

  useEffect(() => {
    setShowILErrorFile(false);
  }, [ilFileData]);

  useEffect(() => {
    setShowSSErrorFile(false);
  }, [ssFileData]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleErrorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const getDefaultValues = (data = {}) => {
    const defaultValues = {
      memberNumber: !isNull(data?.CheckDigit)
        ? `${data?.MemberNumber}-${data?.CheckDigit}`
        : data?.MemberNumber ?? "",
      storeName: data?.StoreName ?? "",
      contactPerson: data?.ContactPerson ?? "",
      contactPhone: data?.ContactPhone ?? "",
      streetAddress: data?.StreetAddress ?? "",
      city: data?.City ?? "",
      state: data?.State ?? "",
      countryCode: data?.CountryCode ?? "",
      zipCode: data?.ZipCode ?? "",
      rdcNumber: data?.RDCNumber ?? "",
      orderTypeId: data?.OrderTypeId ?? "",
      storeSize: data?.StoreSize ?? "",
      linealFootage: data?.LinealFootage ?? "",
      projectTypeId: data?.ProjectTypeId ?? "",
      assignedPlanner: data?.AssignedPlanner ?? "",
      assignedMac: data?.AssignedMac ?? "",
      modelStoreId: data?.ModelStoreNumber ?? "",
      creditLimit: data?.CreditLimit ?? "",
    };
    return defaultValues;
  };

  useEffect(() => {
    // Value should be less than 99 million dollar
    if (!!creditLimitValueWatcher) {
      if (round(creditLimitValueWatcher) <= 99999999) {
        setValue("creditLimit", creditLimitValueWatcher ?? "");
      } else {
        setValue("creditLimit", `${creditLimitValueWatcher}`.substring(0, 8));
      }
    }
  }, [creditLimitValueWatcher, setValue]);

  const restrictAlpha = (e) => {
    let key = e.key;
    if (
      (parseInt(key) >= 0 && parseInt(key) <= 9) ||
      key === "Backspace" ||
      key === "Control" ||
      key === "c" ||
      key === "x" ||
      key === "v" ||
      key === "Copy" ||
      key === "Cut" ||
      key === "Paste" ||
      key === "Tab" ||
      key === "." ||
      key === "-"
    ) {
    } else {
      e.preventDefault();
    }
  };

  const getDataguideFileDetails = useStableCallback(() => {
    requestMaker({
      method: "post",
      url: configData.GetDataguideDetails,
      data: { StoreId: store?.id, UserId: user?.email },
    })
      .then((res) => {
        const details = typeof res?.data === "object" ? res?.data : [];
        setDataguideDetails(details);
        if (details.length > 0) {
          dispatch(
            setDataguideInProgress(
              details[0].Status === UPLOAD_STATUS[2] ? true : false
            )
          );
        } else {
          dispatch(setDataguideInProgress(false));
        }
      })
      .catch((err) => {
        if (err.response.status === 404) {
          setDataguideDetails([]);
          dispatch(setDataguideInProgress(false));
        }
      })
      .finally(() => dispatch(setGlobalLoader(false)));
  });

  useEffect(() => {
    dispatch(setGlobalLoader(true));

    requestMaker({ method: "get", url: configData.GetAllMasterData })
      .then((res) => {
        setCountry(res.data.countrylist);
        setDcNames(res.data.distributioncenter);
        setOtNames(res.data.orderType);
        setPtNames(res.data.projectType);
        setPlanner(res.data.planner);
        setMac(res.data.Mac);
      })
      .catch((err) => console.log(err));

    requestMaker({
      method: "post",
      url: configData.GetOrdersById,
      data: { storeId: store.id },
    })
      .then((res) => {
        const projectDetails = typeof res?.data === "object" ? res?.data : {};
        setDetails(projectDetails);
        dispatch(
          setOrderTypeDetails({
            numberOfItemsPresent: projectDetails?.NumberOfItemsPresent,
            numberOfReleasedItemsPresent:
              projectDetails?.NumberOfReleasedItemsPresent,
          })
        );
        dispatch(
          setFillInOrder(projectDetails?.OrderTypeId === FILL_IN_ORDER_TYPE_ID)
        );
        setInitialModelStoreNumber(projectDetails?.ModelStoreNumber ?? null);
        setInitialModelStoreId(projectDetails?.ModelStoreId ?? null);
        setSelectedStoreId(projectDetails?.ModelStoreId ?? null);
        setCloneStatus(projectDetails?.CloneStatus);
        setArchive(Boolean(projectDetails?.IsArchived));
        setBlockOrderType(
          projectDetails?.OrderTypeId === FILL_IN_ORDER_TYPE_ID
        );
        setSSBlockOrderType(projectDetails?.OrderTypeId === SS_ORDER_TYPE);
        setPurchaseHistory(projectDetails?.IsPurchaseHistory);
        setStoreInventory(projectDetails?.IsStoreInventory);
        reset(getDefaultValues(projectDetails));
        checkCompletedOrderCount(
          projectDetails?.MemberNumber,
          projectDetails?.CheckDigit
        );
      })
      .catch((err) => console.log(err))
      .finally(() => dispatch(setGlobalLoader(false)));

    requestMaker({
      method: "post",
      url: configData.GetFileDetails,
      data: { storeId: store.id },
    })
      .then((res) => {
        const details = typeof res?.data === "object" ? res?.data : [];
        setSIFileDetails(details);
      })
      .catch((err) => console.log(err))
      .finally(() => dispatch(setGlobalLoader(false)));

    requestMaker({
      method: "post",
      url: configData.GetListFileDetails,
      data: { storeId: store.id, fileType: 3 },
    })
      .then((res) => {
        const details = typeof res?.data === "object" ? res?.data : [];
        setSSFileDetails(details);
      })
      .catch((err) => console.log(err))
      .finally(() => dispatch(setGlobalLoader(false)));

    requestMaker({
      method: "post",
      url: configData.GetListFileDetails,
      data: { storeId: store.id, fileType: 1 },
    })
      .then((res) => {
        const details = typeof res?.data === "object" ? res?.data : [];
        setILFileDetails(details);
      })
      .catch((err) => console.log(err))
      .finally(() => dispatch(setGlobalLoader(false)));

    getDataguideFileDetails();
  }, [
    dispatch,
    user?.email,
    store?.id,
    reset,
    requestMaker,
    getDataguideFileDetails,
  ]);

  const saveDetails = useCallback((data) => {
    trackPromise(
      requestMaker({ method: "post", url: configData.UpdateOrder, data })
        .then((res) => {
          // if its cloned need to implicitly set its cloned.
          if (!!data?.modelStoreId) {
            setCloneStatus(true);
          }
          setBlockOrderType(data?.orderTypeId === FILL_IN_ORDER_TYPE_ID);
          setSSBlockOrderType(data?.orderTypeId === SS_ORDER_TYPE);
          setOpen(true);
          setStatus(res.status);
          setInitialModelStoreId(data?.modelStoreId ?? null);
          setSelectedStoreId(data?.modelStoreId ?? null);
          // This condition is for edit path only as in that case store id is present.
          if (store.id) {
            dispatch(
              setStoreDetailsAction({
                id: store.id,
                name: data?.storeName,
                memberNumber: !isNull(data?.checkDigit)
                  ? `${data?.memberNumber}-${data?.checkDigit}`
                  : data?.memberNumber,
                creditLimit: data?.creditLimit,
                pending: data?.isPending,
                rdcNumber: data?.rdcNumber,
                isArchived: Boolean(data?.isArchived),
                isCompleted:
                  data?.statusCode === COMPLETED_STATUS_CODE ? true : false,
                isFillInOrder: data?.orderTypeId === FILL_IN_ORDER_TYPE_ID,
                orderTypeId: data?.orderTypeId,
              })
            );
          }
        })
        .catch(() => {
          setOpen(true);
          setStatus(500);
        })
    );
  }, []);

  const onSubmit = (data) => {
    const memberNumberParts = data.memberNumber?.split("-") || [];
    data.memberNumber = memberNumberParts[0] || null;
    data.checkDigit =
      memberNumberParts.length > 1 ? memberNumberParts[1] : null;
    data.isArchived = Number(archive);
    data.modelStoreId = selectedStoreId;
    const osoCreditLimit = !!data.creditLimit
      ? round(data.creditLimit, 2)
      : null;
    data.storeId = store.id;
    data.statusCode = projStatus;
    data.isPending = Number(pending);
    data.lastUpdatedBy = user.email;
    for (let j = 0; j < numInputs.length; j++) {
      data[numInputs[j]] = parseInt(data[numInputs[j]]);
    }

    for (let i = 0; i < Object.keys(data).length; i++) {
      if (data[Object.keys(data)[i]] === "" || !data[Object.keys(data)[i]]) {
        data[Object.keys(data)[i]] = null;
      }
    }
    data.creditLimit = osoCreditLimit;

    if (!modelStoreValueWatcher) {
      setSelectedStoreId(null);
      setInitialModelStoreId(null);
      data.modelStoreId = null;
    }

    if (modelStoreValueWatcher && !selectedStoreId) {
      setShowErrorDialog(true);
      setErrorTitle("Verify & Select Model Store");
      setErrorContent(
        "Please click on 'Verify & Select' button after entering a Model Store and select a specific store to clone. You can create/edit the project with model store, only by selecting a specific store."
      );
    } else if (store?.id === selectedStoreId) {
      setShowErrorDialog(true);
      setErrorTitle("Verify & Select Model Store");
      setErrorContent(
        "You have selected the same store you are working on as a Model Store. Please select a different Model Store to clone."
      );
    } else if (
      memberNumberValueWatcher.length < 1 &&
      data.orderTypeId === FILL_IN_ORDER_TYPE_ID
    ) {
      dispatch(
        showNotifier({
          message:
            "Member Number is mandatory for Order Type - Fill In. Please add a Member Number.",
          severity: "error",
        })
      );
    } else {
      if (confirmSave && !memberNumberError) {
        saveDetails(data);
      }
    }
  };

  const updateFormDetails = (details = {}) => {
    const selectedRdcCenter = dcNames.find((center) => {
      const firstChars = details?.new_rdc?.substr(0, 2);
      const valueRegex = new RegExp(firstChars, "i");
      return valueRegex.test(center.ConfigValue);
    });

    const selectedCountry = country.find(
      (countryDetails) => countryDetails.CountryName === details?.new_country
    );

    if (!selectedRdcCenter && details?.new_rdc) {
      setOtherHelperText((prevState) => ({
        ...prevState,
        distributionCenter: `No match found: ${details?.new_rdc}`,
      }));
    }

    if (!selectedCountry && details?.new_country) {
      setOtherHelperText((prevState) => ({
        ...prevState,
        country: `No match found: ${details?.new_country}`,
      }));
    }

    const selectedProjectType = ptNames.find(
      (projectType) => projectType.ConfigValue === details?.new_projecttype
    );

    const selectedPlanner = planner.find(
      (planner) => planner.Name === details?.new_dtvprojectplannerid?.new_name
    );

    if (!selectedPlanner && details?.new_dtvprojectplannerid?.new_name) {
      setOtherHelperText((prevState) => ({
        ...prevState,
        planner: `No match found: ${details?.new_dtvprojectplannerid?.new_name}`,
      }));
    }

    const selectedMac = mac.find(
      (mac) => mac.Name === details?.new_macid?.new_name
    );

    if (!selectedMac && details?.new_macid?.new_name) {
      setOtherHelperText((prevState) => ({
        ...prevState,
        mac: `No match found: ${details?.new_macid?.new_name}`,
      }));
    }

    reset({
      memberNumber: memberNumberValueWatcher,
      storeName: details?.new_storename?.name ?? "",
      contactPerson: details?.new_storecontactname ?? "",
      contactPhone: details?.new_cellphone ?? "",
      city: details?.new_city ?? "",
      state: details?.new_state ?? "",
      zipCode: details?.new_zipcode ?? "",
      orderTypeId: details?.new_ordertype ?? "",
      streetAddress: details?.new_mailingstreet ?? "",
      countryCode: selectedCountry?.CountryId ?? "",
      rdcNumber: selectedRdcCenter?.ConfigKey ?? "",
      storeSize: details?.new_tvhardwaresqft ?? "",
      linealFootage: details?.new_tvlineal ?? "",
      projectTypeId: selectedProjectType?.ConfigKey ?? "",
      assignedPlanner: selectedPlanner?.UserId ?? "",
      assignedMac: selectedMac?.UserId ?? "",
      modelStoreId: modelStoreValueWatcher,
      creditLimit: details?.new_estosoamount ?? "",
    });
  };

  const handleGetCRMDetails = useCallback(() => {
    setOtherHelperText({
      country: "",
      distributionCenter: "",
      planner: "",
      mac: "",
    });
    clearErrors();
    trackPromise(
      requestMaker({
        method: "post",
        url: configData.GetStoreDetails,
        data: { membernumber: String(memberNumberValueWatcher) },
      })
        .then((res) => {
          const availableStores = res?.data ?? [];
          setStoreDetails(availableStores);
          if (!availableStores.length) {
            reset({
              memberNumber: memberNumberValueWatcher,
              storeName: "",
              contactPerson: "",
              contactPhone: "",
              city: "",
              state: "",
              zipCode: "",
              orderTypeId: "",
              streetAddress: "",
              countryCode: "",
              rdcNumber: "",
              storeSize: "",
              linealFootage: "",
              creditLimit: "",
              projectTypeId: "",
              assignedMac: "",
              assignedPlanner: "",
              modelStoreId: modelStoreValueWatcher,
            });
            return snackbarShowMessage(
              `No details found for a given member number: ${memberNumberValueWatcher}. If you are using check digit then please remove it and try again.`,
              "info"
            );
          }

          if (availableStores.length === 1) {
            updateFormDetails(availableStores[selectedStoreIndex]);
          } else {
            setIsCRMStore(true);
            setShowStoreDialog(true);
          }
        })
        .catch((err) => {
          handleCommonError(snackbarShowMessage);
        })
    );
  }, [
    requestMaker,
    updateFormDetails,
    memberNumberValueWatcher,
    modelStoreValueWatcher,
    clearErrors,
    reset,
    selectedStoreIndex,
    snackbarShowMessage,
  ]);

  const getModelStore = useCallback(() => {
    const modelStoreParts = modelStoreValueWatcher?.split("-") || [];
    trackPromise(
      requestMaker({
        method: "post",
        url: configData.GetModelStoreDetails,
        data: {
          memberNumber: modelStoreParts[0] || null,
          checkDigit: modelStoreParts.length > 1 ? modelStoreParts[1] : null,
        },
      })
        .then((res) => {
          const availableModelStores = res?.data ?? [];
          setModelStoreDetails(availableModelStores);
          if (!availableModelStores.length) {
            return snackbarShowMessage(
              `No details found for a given model store: ${modelStoreValueWatcher}`,
              "info"
            );
          } else {
            setIsCRMStore(false);
            setShowStoreDialog(true);
          }
        })
        .catch((err) => {
          handleCommonError(snackbarShowMessage);
        })
    );
  }, [requestMaker, modelStoreValueWatcher, snackbarShowMessage]);

  const handleGetModelStoreDetails = useCallback(() => {
    clearErrors();
    if (store?.numberOfItemsPresent > 0) {
      setShowModelStoreWarningDialog(true);
      return true;
    }
    getModelStore();
  }, [clearErrors, getModelStore, store?.numberOfItemsPresent]);

  const memberNumberError = useMemo(
    () =>
      memberNumberValueWatcher.length < 1 &&
      orderTypeValueWatcher === FILL_IN_ORDER_TYPE_ID,
    [memberNumberValueWatcher, orderTypeValueWatcher]
  );

  const disableGetCRMDetails = useMemo(
    () =>
      !memberNumberValueWatcher ||
      memberNumberValueWatcher?.toString()?.trim().length === 0 ||
      errors?.memberNumber,
    [memberNumberValueWatcher, errors?.memberNumber]
  );

  const handleStoreSelection = useCallback((storeIndex) => {
    setSelectedStoreIndex(storeIndex);
  }, []);

  const handleStoreDialogCancel = useCallback(() => {
    setSelectedStoreIndex(0);
    setShowStoreDialog(false);
    if (!isCRMStore) {
      setSelectedStoreId(null);
    }
  }, []);

  const handleStoreDialogDone = useCallback(() => {
    handleStoreDialogCancel();
    if (isCRMStore) {
      updateFormDetails(storeDetails[selectedStoreIndex]);
    } else {
      const id = modelStoreDetails[selectedStoreIndex]?.StoreId;
      setSelectedStoreId(id);
      if (details?.IsModified && id !== initialModelStoreId) {
        setShowConfirmDialog(true);
      } else {
        setConfirmSave(true);
      }
    }
  }, [
    storeDetails,
    modelStoreDetails,
    handleStoreDialogCancel,
    selectedStoreIndex,
  ]);

  const handleSSDialogNo = useStableCallback(() => {
    setOrderTypeIdCache(null);
    setStoreSuppliesWarningDialog(false);
  });

  const handleSSDialogYes = useStableCallback(() => {
    setValue("orderTypeId", orderTypeIdCache);
    setValue("modelStoreId", "");
    setCloneStatus(false);
    handleSSDialogNo(false);
  });

  const handleSIPHDialogNo = useCallback((isFromYes = false) => {
    if (!isFromYes) {
      delay(() => {
        setTypeSelected("");
      }, 300);
    }
    setShowSIPHDialog(false);
  }, []);

  const handleSIPHDialogYes = useCallback(() => {
    handleSIPHDialogNo(true);
    trackPromise(
      requestMaker({
        method: "post",
        url: configData.ToggleStoreInvPurchaseHistory,
        data: {
          storeId: store.id,
          userId: user.email,
          isPurchaseHistorySelected:
            typeSelected === "PH" ? !purchaseHistory : purchaseHistory,
          isStoreInventorySelected:
            typeSelected !== "PH" ? !storeInventory : storeInventory,
        },
      })
        .then(() => {
          delay(() => {
            if (typeSelected === "PH") {
              setPurchaseHistory((oldVal) => !oldVal);
            } else {
              setStoreInventory((oldVal) => !oldVal);
            }
            setTypeSelected("");
          }, 200);
          dispatch(
            showNotifier({
              message: "Changes applied successfully",
            })
          );
        })
        .catch(() => {
          handleCommonError(snackbarShowMessage);
          setTypeSelected("");
        })
    );
  }, [
    dispatch,
    requestMaker,
    handleSIPHDialogNo,
    snackbarShowMessage,
    store.id,
    user.email,
    purchaseHistory,
    storeInventory,
    typeSelected,
  ]);

  const handleConfirmDialogNo = useCallback(() => {
    setConfirmSave(false);
    setSelectedStoreId(null);
    setShowConfirmDialog(false);
  }, []);

  const handleConfirmDialogYes = useCallback(() => {
    setConfirmSave(true);
    setShowConfirmDialog(false);
  }, []);

  const handleOrderTypeDialogNo = useCallback(() => {
    setOrderTypeIdCache(null);
    setShowOrderTypeWarningDialog(false);
  }, []);

  const handleOrderTypeDialogYes = useCallback(() => {
    setValue("orderTypeId", orderTypeIdCache);
    handleOrderTypeDialogNo();
  }, [handleOrderTypeDialogNo, setValue, orderTypeIdCache]);

  const handleModelStoreDialogNo = useCallback(() => {
    setShowModelStoreWarningDialog(false);
  }, []);

  const handleModelStoreDialogYes = useCallback(() => {
    handleModelStoreDialogNo();
    getModelStore();
  }, [handleModelStoreDialogNo, getModelStore]);

  const isModelStoreValid = useMemo(() => {
    if (modelStoreValueWatcher) {
      const regex = MemberNoValidation.pattern.value;
      return (
        regex.test(modelStoreValueWatcher) && modelStoreValueWatcher.length >= 1
      );
    }
    return true;
  }, [modelStoreValueWatcher]);

  const modelStoreError = useMemo(
    () => !isModelStoreValid || (modelStoreValueWatcher && !selectedStoreId),
    [isModelStoreValid, modelStoreValueWatcher, selectedStoreId]
  );

  const handleErrorDialogClose = useCallback(() => {
    setShowErrorDialog(false);
  }, []);

  const modelStoreHelperText = useMemo(() => {
    let helperText = "";
    if (
      !!selectedStoreId &&
      selectedStoreId === initialModelStoreId &&
      Boolean(cloneStatus)
    ) {
      helperText = "Project is cloned with above model store";
    }
    if (!isModelStoreValid) {
      helperText = "Please enter a valid model store number";
    }
    return helperText;
  }, [isModelStoreValid, cloneStatus, selectedStoreId, initialModelStoreId]);

  const disableGetModelStoreDetails = useMemo(
    () =>
      modelStoreValueWatcher?.toString()?.trim().length < 1 ||
      !isModelStoreValid,
    [modelStoreValueWatcher, isModelStoreValid]
  );

  const disableFields = useMemo(
    () =>
      pending ||
      !canEditPermission ||
      isProjectArchived ||
      archive ||
      projStatus === COMPLETED_STATUS_CODE ||
      store?.isCompleted,
    [
      pending,
      canEditPermission,
      isProjectArchived,
      archive,
      projStatus,
      store?.isCompleted,
    ]
  );

  const disableStatus = useMemo(
    () => !canEditPermission || isProjectArchived || archive,
    [canEditPermission, isProjectArchived, archive]
  );

  const handleSIFileUpload = useCallback(
    (file) => {
      setShowUploadedSIFile(false);
      const data = new FormData();
      setFileUploading({ ...fileUploading, storeInv: true });
      dispatch(setGlobalLoader(true));
      data.append("File", file[0]);
      data.append("storeId", store.id);
      data.append("userId", user.email);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      requestMaker({
        method: "post",
        url: configData.InventoryFileUpload,
        data,
        config,
      })
        .then((res) => {
          setFileUploading({ ...fileUploading, storeInv: false });
          dispatch(setGlobalLoader(false));
          const successLink = res?.data?.SignedUploadedFileURL;
          const errorLink = res?.data?.SignedErrorFileURL;
          const message = res?.data?.Message;
          if (successLink && !errorLink) {
            setSIFileName(file[0].name);
            setUploadedSIFileLink(successLink);
            setShowUploadedSIFile(true);
            dispatch(
              showNotifier({
                message: "File uploaded successfully",
              })
            );
          }
          if (errorLink) {
            setErrorSIFileLink(errorLink);
            setShowSIErrorFile(true);
            setUploadedSIFileLink(successLink);
            dispatch(
              showNotifier({
                message:
                  message ?? "File upload failed due to error in the file",
                severity: "error",
              })
            );
          }
          if (!successLink && !errorLink && message) {
            dispatch(
              showNotifier({
                message: message,
                severity: "error",
              })
            );
          }

          requestMaker({
            method: "post",
            url: configData.GetFileDetails,
            data: { storeId: store.id },
          })
            .then((res) => {
              const details = typeof res?.data === "object" ? res?.data : [];
              setSIFileDetails(details);
            })
            .catch((err) => console.log(err))
            .finally(() => dispatch(setGlobalLoader(false)));
        })
        .catch((err) => {
          setFileUploading({ ...fileUploading, storeInv: false });
          dispatch(setGlobalLoader(false));
          if (err.response.status === 404) {
            dispatch(
              showNotifier({
                message: err.response.data,
                severity: "error",
              })
            );
          } else {
            dispatch(
              showNotifier({
                message: "File upload failed",
                severity: "error",
              })
            );
          }
        });
    },
    [dispatch]
  );

  const handlePurchaseHistoryToggle =
    (isPhSelected = false) =>
    () => {
      setTypeSelected(isPhSelected ? "PH" : "SI");
      setShowSIPHDialog(true);
    };

  const handleDataguideUpload = useStableCallback((file) => {
    const data = new FormData();
    setFileUploading({ ...fileUploading, dataguide: true });
    dispatch(setGlobalLoader(true));
    data.append("File", file[0]);
    data.append("StoreId", store?.id);
    data.append("UserId", user?.email);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    requestMaker({
      method: "post",
      url: configData.DataguideUpload,
      data,
      config,
    })
      .then((res) => {
        // Get Dataguide Upload History
        requestMaker({
          method: "post",
          url: configData.GetDataguideDetails,
          data: { StoreId: store?.id, UserId: user?.email },
        })
          .then((res) => {
            const details = typeof res?.data === "object" ? res?.data : [];
            setDataguideDetails(details);
            if (details.length > 0) {
              dispatch(
                setDataguideInProgress(
                  details[0].Status === UPLOAD_STATUS[2] ? true : false
                )
              );
            } else {
              dispatch(setDataguideInProgress(false));
            }

            if (details.length > 0) {
              requestMaker({
                method: "post",
                url: configData.SaveDataguide,
                data: { StoreId: store?.id, FileId: details[0].FileId },
              })
                .then((res) => {
                  dispatch(
                    showNotifier({
                      message: "Dataguide uploaded successfully",
                    })
                  );
                })
                .catch((err) =>
                  dispatch(
                    showNotifier({
                      message: "Dataguide upload failed",
                      severity: "error",
                    })
                  )
                )
                .finally(() =>
                  requestMaker({
                    method: "post",
                    url: configData.GetDataguideDetails,
                    data: { StoreId: store?.id, UserId: user?.email },
                  })
                    .then((res) => {
                      const details =
                        typeof res?.data === "object" ? res?.data : [];
                      setDataguideDetails(details);
                      if (details.length > 0) {
                        dispatch(
                          setDataguideInProgress(
                            details[0].Status === UPLOAD_STATUS[2]
                              ? true
                              : false
                          )
                        );
                      } else {
                        dispatch(setDataguideInProgress(false));
                      }
                    })
                    .catch((err) => {
                      if (err.response.status === 404) {
                        setDataguideDetails([]);
                        dispatch(setDataguideInProgress(false));
                      }
                    })
                );
            }
          })
          .catch((err) => {
            if (err.response.status === 404) {
              setDataguideDetails([]);
              dispatch(setDataguideInProgress(false));
            }
          });
      })
      .catch((err) => {
        if (err.response.status === 404) {
          dispatch(
            showNotifier({
              message: err.response.data,
              severity: "error",
            })
          );
        } else {
          dispatch(
            showNotifier({
              message: "Dataguide upload failed",
              severity: "error",
            })
          );
        }
      })
      .finally(() => {
        setFileUploading({ ...fileUploading, dataguide: false });
        dispatch(setGlobalLoader(false));
      });
  });

  const handleOSOItemListUpload = useCallback(
    (file) => {
      setShowUploadedILFile(false);
      const data = new FormData();
      setFileUploading({ ...fileUploading, OSOItemList: true });
      dispatch(setGlobalLoader(true));
      data.append("File", file[0]);
      data.append("storeId", store.id);
      data.append("userId", user.email);
      data.append("isItemUpload", 1);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      requestMaker({
        method: "post",
        url: configData.ItemListFileUpload,
        data,
        config,
      })
        .then((res) => {
          setFileUploading({ ...fileUploading, OSOItemList: false });
          dispatch(setGlobalLoader(false));
          const successLink = res?.data?.SignedUploadedFileURL;
          const errorLink = res?.data?.SignedErrorFileURL;
          const message = res?.data?.Message;
          if (successLink && !errorLink) {
            setILFileName(file[0].name);
            setUploadedILFileLink(successLink);
            setShowUploadedILFile(true);
            dispatch(
              showNotifier({
                message: "File uploaded successfully",
              })
            );
          }
          if (errorLink) {
            setErrorILFileLink(errorLink);
            setShowILErrorFile(true);
            setUploadedILFileLink(successLink);
            dispatch(
              showNotifier({
                message:
                  message ?? "File upload failed due to error in the file",
                severity: "error",
              })
            );
          }
          if (!successLink && !errorLink && message) {
            dispatch(
              showNotifier({
                message: message,
                severity: "error",
              })
            );
          }

          requestMaker({
            method: "post",
            url: configData.GetListFileDetails,
            data: { storeId: store.id, fileType: 1 },
          })
            .then((res) => {
              const details = typeof res?.data === "object" ? res?.data : [];
              setILFileDetails(details);
            })
            .catch((err) => console.log(err))
            .finally(() => dispatch(setGlobalLoader(false)));
        })
        .catch((err) => {
          setFileUploading({ ...fileUploading, OSOItemList: false });
          dispatch(setGlobalLoader(false));
          if (err.response.status === 404) {
            dispatch(
              showNotifier({
                message: err.response.data,
                severity: "error",
              })
            );
          } else {
            dispatch(
              showNotifier({
                message: "File upload failed",
                severity: "error",
              })
            );
          }
        });
    },
    [dispatch]
  );

  const handleSSItemListUpload = useCallback(
    (file) => {
      setShowUploadedSSFile(false);
      const data = new FormData();
      setFileUploading({ ...fileUploading, SSItemList: true });
      dispatch(setGlobalLoader(true));
      data.append("File", file[0]);
      data.append("storeId", store.id);
      data.append("userId", user.email);
      data.append("isItemUpload", 3);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      requestMaker({
        method: "post",
        url: configData.ItemListFileUpload,
        data,
        config,
      })
        .then((res) => {
          setFileUploading({ ...fileUploading, SSItemList: false });
          dispatch(setGlobalLoader(false));
          const successLink = res?.data?.SignedUploadedFileURL;
          const errorLink = res?.data?.SignedErrorFileURL;
          const message = res?.data?.Message;
          if (successLink && !errorLink) {
            setSSFileName(file[0].name);
            setUploadedSSFileLink(successLink);
            setShowUploadedSSFile(true);
            dispatch(
              showNotifier({
                message: "File uploaded successfully",
              })
            );
          }
          if (errorLink) {
            setErrorSSFileLink(errorLink);
            setShowSSErrorFile(true);
            setUploadedSSFileLink(successLink);
            dispatch(
              showNotifier({
                message:
                  message ?? "File upload failed due to error in the file",
                severity: "error",
              })
            );
          }
          if (!successLink && !errorLink && message) {
            dispatch(
              showNotifier({
                message: message,
                severity: "error",
              })
            );
          }

          requestMaker({
            method: "post",
            url: configData.GetListFileDetails,
            data: { storeId: store.id, fileType: 3 },
          })
            .then((res) => {
              const details = typeof res?.data === "object" ? res?.data : [];
              setSSFileDetails(details);
            })
            .catch((err) => console.log(err))
            .finally(() => dispatch(setGlobalLoader(false)));
        })
        .catch((err) => {
          setFileUploading({ ...fileUploading, SSItemList: false });
          dispatch(setGlobalLoader(false));
          if (err.response.status === 404) {
            dispatch(
              showNotifier({
                message: err.response.data,
                severity: "error",
              })
            );
          } else {
            dispatch(
              showNotifier({
                message: "File upload failed",
                severity: "error",
              })
            );
          }
        });
    },
    [dispatch]
  );

  const handleSISync = useCallback(() => {
    setSISyncing(true);
    requestMaker({
      method: "post",
      url: configData.SyncInventoryData,
      data: { storeId: store.id },
    })
      .then((res) => {
        setSISyncing(false);
        if (typeof res?.data === "object") {
          dispatch(
            showNotifier({
              message: res?.data?.message,
              severity: res?.data?.severity,
            })
          );
        } else {
          dispatch(
            showNotifier({
              message: "Something went wrong. Please try again.",
              severity: "error",
            })
          );
        }
      })
      .catch((err) => {
        setSISyncing(false);
        dispatch(
          showNotifier({
            message: "Something went wrong. Please try again.",
            severity: "error",
          })
        );
      });
  }, [dispatch]);

  const handlePHSync = useCallback(() => {
    setPHSyncing(true);
    requestMaker({
      method: "post",
      url: configData.SyncPurchaseHistoryData,
      data: { storeId: store.id },
    })
      .then((res) => {
        if (typeof res?.data === "object") {
          dispatch(
            showNotifier({
              message: res?.data?.message,
              severity: res?.data?.severity,
            })
          );
        } else {
          dispatch(
            showNotifier({
              message: "Something went wrong. Please try again.",
              severity: "error",
            })
          );
        }
      })
      .catch((err) => {
        dispatch(
          showNotifier({
            message: "Something went wrong. Please try again.",
            severity: "error",
          })
        );
      })
      .finally(() => {
        setPHSyncing(false);
      });
  }, [dispatch]);

  const downloadSITemplate = useCallback(() => {
    trackPromise(
      requestMaker({
        method: "post",
        url: configData.FileTemplateDownload,
        data: {
          fileType: "Inventory",
        },
      })
        .then((res) => {
          const url = res?.data;
          window.location.assign(url, "_blank");
        })
        .catch(() => {
          dispatch(
            showNotifier({
              message: "Something went wrong. Please try again.",
              severity: "error",
            })
          );
        })
    );
  }, [dispatch]);

  const downloadILTemplate = useCallback(() => {
    trackPromise(
      requestMaker({
        method: "post",
        url: configData.FileTemplateDownload,
        data: {
          FileType: "ItemUpload",
        },
      })
        .then((res) => {
          const url = res?.data;
          window.location.assign(url, "_blank");
        })
        .catch(() => {
          dispatch(
            showNotifier({
              message: "Something went wrong. Please try again.",
              severity: "error",
            })
          );
        })
    );
  }, [dispatch]);

  const downloadSSTemplate = useCallback(() => {
    trackPromise(
      requestMaker({
        method: "post",
        url: configData.FileTemplateDownload,
        data: {
          FileType: "StoreSuppliesItemUpload",
        },
      })
        .then((res) => {
          const url = res?.data;
          window.location.assign(url, "_blank");
        })
        .catch(() => {
          dispatch(
            showNotifier({
              message: "Something went wrong. Please try again.",
              severity: "error",
            })
          );
        })
    );
  }, [dispatch]);

  const downloadDataguide = useStableCallback(() => {
    trackPromise(
      requestMaker({
        method: "post",
        url: configData.DataguideDownload,
        data: { StoreId: store?.id, UserId: user?.email },
      })
        .then((res) => {
          const url = res?.data;
          window.location.assign(url, "_blank");
          getDataguideFileDetails();
        })
        .catch(() => {
          dispatch(
            showNotifier({
              message: "Something went wrong. Please try again.",
              severity: "error",
            })
          );
          getDataguideFileDetails();
        })
    );
  });

  const memberNumberBlurHandler = (e) => {
    if (!memberNumberValueWatcher || errors?.memberNumber) {
      return;
    }
    const memberNumberParts =
      String(memberNumberValueWatcher)?.split("-") || [];
    const _memberNumber = memberNumberParts[0] || null;
    const _checkDigit =
      memberNumberParts.length > 1 ? memberNumberParts[1] : null;
    checkCompletedOrderCount(_memberNumber, _checkDigit);
  };

  const handleOrderTypeChange = (e) => {
    const type = e?.target?.value ?? null;
    if (
      type === 6 &&
      Boolean(cloneStatus) &&
      store.numberOfReleasedItemsPresent === 0
    ) {
      setOrderTypeIdCache(e?.target?.value ?? null);
      return setStoreSuppliesWarningDialog(true);
    }
    if (type === FILL_IN_ORDER_TYPE_ID && !memberNumberValueWatcher) {
      return dispatch(
        showNotifier({
          message: "Member number is required.",
          severity: "error",
        })
      );
    }
    if (type === FILL_IN_ORDER_TYPE_ID && store.numberOfItemsPresent > 0) {
      setOrderTypeIdCache(e?.target?.value ?? null);
      setShowOrderTypeWarningDialog(true);
    } else {
      setValue("orderTypeId", e?.target?.value);
    }
  };

  const checkCompletedOrderCount = (memberNumber, checkDigit) => {
    requestMaker({
      method: "post",
      url: configData.GetCountOfCompletedOrders,
      data: {
        memberNumber,
        checkDigit,
      },
    })
      .then((res) => {
        dispatch(setCompletedOrderCount(res?.data));
      })
      .catch((_err) => {});
  };

  const isInvalidForInventory = useMemo(() => {
    if (isEmpty(store?.memberNumber)) {
      return true;
    }
    if (store?.memberNumber !== memberNumberValueWatcher) {
      return true;
    }
    return (
      !!(errors?.memberNumber || memberNumberError) || !memberNumberValueWatcher
    );
  }, [
    errors?.memberNumber,
    memberNumberError,
    memberNumberValueWatcher,
    store?.memberNumber,
  ]);

  const isInvalidForDataguide = useMemo(() => {
    // NOTE: removed member number null/empty validtion as client wanted to uploaded
    // a dataguide without member number.
    if (store?.memberNumber !== memberNumberValueWatcher) {
      return true;
    }
    return !!(errors?.memberNumber || memberNumberError);
  }, [
    errors?.memberNumber,
    memberNumberError,
    memberNumberValueWatcher,
    store?.memberNumber,
  ]);

  const isSSOrderType =
    details?.OrderTypeId === SS_ORDER_TYPE || blockSSOrderType;

  return (
    <>
      {details ? (
        <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
          <Container maxWidth="xl" sx={{ paddingY: 1 }}>
            <Box
              sx={{ display: "flex", flexDirection: "column" }}
              marginTop={1}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  sx={{ fontWeight: "bold", fontSize: 17, mr: 2 }}
                  component="p"
                >
                  Store Information
                </Typography>
              </Box>
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  padding: 3,
                  marginY: 1,
                }}
              >
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                    sm={4}
                    md={3}
                    lg={3}
                  >
                    <Grid
                      item
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                      }}
                    >
                      <Grid item lg={6}>
                        <TextFieldControl
                          name="memberNumber"
                          control={control}
                          disabled={
                            siFileDetails.length ||
                            ilFileDetails.length ||
                            purchaseHistory ||
                            disableFields ||
                            orderTypeValueWatcher === FILL_IN_ORDER_TYPE_ID
                          }
                          tooltipTitle="Enter Member Number"
                          label="Member Number"
                          required={false}
                          sx={{ width: "98%" }}
                          inputProps={{
                            maxLength: 7,
                          }}
                          rules={{
                            ...MemberNoValidation,
                          }}
                          error={errors?.memberNumber || memberNumberError}
                          firstError={firstError}
                          overrideHandlers={{
                            onBlur: memberNumberBlurHandler,
                          }}
                          FormHelperTextProps={{
                            sx: {
                              textWrap: "nowrap",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item lg={6} mt={1.5}>
                        <Button
                          size="small"
                          onClick={handleGetCRMDetails}
                          disabled={
                            siFileDetails.length ||
                            ilFileDetails.length ||
                            purchaseHistory ||
                            disableGetCRMDetails ||
                            disableFields ||
                            orderTypeValueWatcher === FILL_IN_ORDER_TYPE_ID ||
                            isSSOrderType
                          }
                        >
                          Get CRM Details
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <TextFieldControl
                      name="storeName"
                      control={control}
                      error={errors?.storeName}
                      firstError={firstError}
                      disabled={disableFields}
                      rules={{
                        required: {
                          value: true,
                          message: "This field is required.",
                        },
                      }}
                      tooltipTitle="Enter Store Name (Max 100 characters)"
                      label="Store Name"
                      inputProps={{ maxLength: 100 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <TextFieldControl
                      name="contactPerson"
                      control={control}
                      tooltipTitle="Enter Contact Person Name (Max 100 characters)"
                      label="Contact Person"
                      inputProps={{ maxLength: 100 }}
                      required={false}
                      disabled={disableFields}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <TextFieldControl
                      name="contactPhone"
                      control={control}
                      tooltipTitle="Enter Phone Number in this format: 000-000-0000"
                      label="Phone"
                      disabled={disableFields}
                      inputProps={{
                        maxLength: 12,
                        inputMode: "tel",
                      }}
                      required={false}
                      onKeyDown={restrictAlpha}
                      error={errors?.contactPhone}
                      firstError={firstError}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <TextFieldControl
                      name="streetAddress"
                      control={control}
                      tooltipTitle="Enter Store's Street Address (Max 500 characters)"
                      label="Delivery Street Address"
                      disabled={disableFields}
                      inputProps={{ maxLength: 500 }}
                      required={false}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <TextFieldControl
                      name="city"
                      control={control}
                      error={errors?.city}
                      disabled={disableFields}
                      rules={{
                        required: {
                          value: true,
                          message: "This field is required.",
                        },
                      }}
                      tooltipTitle="Enter Store's City (Max 100 characters)"
                      label="Delivery City"
                      inputProps={{ maxLength: 100 }}
                      firstError={firstError}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <TextFieldControl
                      name="state"
                      control={control}
                      tooltipTitle="Enter Store's State (Max 100 characters)"
                      label="Delivery State"
                      disabled={disableFields}
                      inputProps={{ maxLength: 100 }}
                      required={false}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <SelectControl
                      name="countryCode"
                      control={control}
                      label="Country"
                      disabled={disableFields}
                      optionList={country}
                      required={false}
                      optionKey="CountryId"
                      optionValue="CountryName"
                      helperText={otherHelperText.country}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <TextFieldControl
                      name="zipCode"
                      control={control}
                      tooltipTitle="Enter Store's Zip Code (Max 9 digits)"
                      label="Delivery Zip Code"
                      disabled={disableFields}
                      inputProps={{ maxLength: 9, inputMode: "numeric" }}
                      onKeyDown={restrictAlpha}
                      required={false}
                      rules={{
                        pattern: {
                          value: /^[0-9\b]+$/,
                          message: "Please enter number upto 9 digits",
                        },
                      }}
                      error={errors?.zipCode}
                      firstError={firstError}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <SelectControl
                      name="rdcNumber"
                      control={control}
                      label="Distribution Center"
                      optionList={dcNames}
                      required={false}
                      disabled={disableFields}
                      optionKey="ConfigKey"
                      optionValue="ConfigValue"
                      helperText={otherHelperText.distributionCenter}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <SelectControl
                      name="orderTypeId"
                      control={control}
                      label="Order Type"
                      optionList={otNames}
                      required={false}
                      disabled={
                        disableFields || blockOrderType || isSSOrderType
                      }
                      optionKey="ConfigKey"
                      optionValue="ConfigValue"
                      disabledOptionKey={[
                        store?.completedOrderCount === 0 || // If no history of completed orders with this member number presents then no fill in
                        store?.numberOfReleasedItemsPresent > 0
                          ? FILL_IN_ORDER_TYPE_ID
                          : -1, // For Fill In
                        store?.numberOfReleasedItemsPresent > 0 ? 6 : -1, // For Store Supplies
                      ]}
                      overrideHandlers={{
                        onChange: handleOrderTypeChange,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <TextFieldControl
                      name="storeSize"
                      control={control}
                      tooltipTitle="Enter Store Size (sq ft)"
                      label="Store Size"
                      disabled={disableFields}
                      inputProps={{ maxLength: 5 }}
                      onKeyDown={restrictAlpha}
                      required={false}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">sq ft</InputAdornment>
                        ),
                      }}
                      rules={{
                        pattern: {
                          value: /^[0-9]{0,5}$/,
                          message: "Please enter store size of max 5 digits",
                        },
                      }}
                      error={errors?.storeSize}
                      firstError={firstError}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <TextFieldControl
                      name="linealFootage"
                      control={control}
                      tooltipTitle="Enter Lineal Footage (sq ft)"
                      label="Lineal Footage"
                      disabled={disableFields}
                      inputProps={{ maxLength: 5 }}
                      onKeyDown={restrictAlpha}
                      required={false}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">sq ft</InputAdornment>
                        ),
                      }}
                      rules={{
                        pattern: {
                          value: /^[0-9]{0,5}$/,
                          message:
                            "Please enter lineal footage of max 5 digits",
                        },
                      }}
                      error={errors?.linealFootage}
                      firstError={firstError}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Box>
            <Box
              sx={{ display: "flex", flexDirection: "column" }}
              marginTop={1}
            >
              <Typography
                sx={{ fontWeight: "bold", fontSize: 17 }}
                component="p"
              >
                Project Information
              </Typography>
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  padding: 3,
                  marginY: 1,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <SelectControl
                      name="projectTypeId"
                      control={control}
                      label="Project Type"
                      optionList={ptNames}
                      disabled={disableFields}
                      optionKey="ConfigKey"
                      optionValue="ConfigValue"
                      error={errors?.projectTypeId}
                      rules={{
                        required: {
                          value: true,
                          message: "This field is required.",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <SelectControl
                      name="assignedPlanner"
                      control={control}
                      label="Project Planner"
                      optionList={planner}
                      optionKey="UserId"
                      optionValue="UserId"
                      optionLabel="Name"
                      disabled={disableFields}
                      error={errors?.assignedPlanner}
                      rules={{
                        required: {
                          value: true,
                          message: "This field is required.",
                        },
                      }}
                      helperText={otherHelperText.planner}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <SelectControl
                      name="assignedMac"
                      control={control}
                      label="Assigned MAC"
                      optionList={mac}
                      disabled={disableFields}
                      optionKey="UserId"
                      optionValue="UserId"
                      optionLabel="Name"
                      required={false}
                      helperText={otherHelperText.mac}
                    />
                  </Grid>
                  {orderTypeValueWatcher !== FILL_IN_ORDER_TYPE_ID && (
                    <Grid
                      item
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                      xs={12}
                      sm={4}
                      md={3}
                      lg={3}
                    >
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-start",
                          alignSelf: "baseline",
                        }}
                      >
                        <Grid item lg={6}>
                          <TextFieldControl
                            name="modelStoreId"
                            control={control}
                            disabled={
                              disableFields ||
                              store?.numberOfReleasedItemsPresent > 0 ||
                              store?.isStoreSupplies ||
                              orderTypeValueWatcher === 6
                            }
                            tooltipTitle="Enter Model Store"
                            label="Model Store"
                            required={false}
                            sx={{ width: "98%" }}
                            inputProps={{ maxLength: 7 }}
                            error={modelStoreError}
                            helperText={modelStoreHelperText}
                            FormHelperTextProps={{
                              sx: {
                                textWrap: "nowrap",
                              },
                            }}
                          />
                        </Grid>
                        <Grid item lg={6} mt={1.5}>
                          <Button
                            size="small"
                            onClick={handleGetModelStoreDetails}
                            disabled={
                              disableGetModelStoreDetails ||
                              disableFields ||
                              store?.numberOfReleasedItemsPresent > 0 ||
                              store?.isStoreSupplies ||
                              orderTypeValueWatcher === 6
                            }
                          >
                            Verify & Select
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Paper>
            </Box>
            <Box
              sx={{ display: "flex", flexDirection: "column" }}
              marginTop={1}
            >
              <Typography
                sx={{ fontWeight: "bold", fontSize: 17 }}
                component="p"
              >
                Credit Information
              </Typography>
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  padding: 3,
                  marginY: 1,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4} md={3} lg={3}>
                    <TextFieldControl
                      name="creditLimit"
                      control={control}
                      label="OSO Credit Limit"
                      tooltipTitle="Enter OSO Credit Limit ($)"
                      disabled={disableFields}
                      inputProps={{
                        inputMode: "numeric",
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                      rules={{
                        pattern: {
                          value: /^[1-9]\d*(\.\d+)?$/,
                          message: "Please enter valid amount",
                        },
                      }}
                      required={false}
                      error={errors?.creditLimit}
                      firstError={firstError}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Box>
            <Box
              sx={{ display: "flex", flexDirection: "column" }}
              marginTop={1}
            >
              <Typography
                sx={{ fontWeight: "bold", fontSize: 17 }}
                component="p"
              >
                Inventory/Purchase History
              </Typography>
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  padding: 3,
                  flexDirection: "column",
                  marginTop: 1,
                  marginBottom: 1,
                }}
              >
                <Grid container spacing={1} mb={2} alignItems="center">
                  <Grid item xs={12} sm={4} md={2} lg={2}>
                    Synchronize Data:
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} lg={2}>
                    <LoadingButton
                      size="small"
                      onClick={handleSISync}
                      endIcon={<SyncIcon />}
                      loading={siSyncing}
                      loadingPosition="end"
                      variant="contained"
                      disabled={
                        disableFields || isInvalidForInventory || isSSOrderType
                      }
                    >
                      Store Inventory
                    </LoadingButton>
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} lg={2}>
                    <LoadingButton
                      size="small"
                      onClick={handlePHSync}
                      endIcon={<SyncIcon />}
                      loading={phSyncing}
                      loadingPosition="end"
                      variant="contained"
                      disabled={
                        disableFields || isInvalidForInventory || isSSOrderType
                      }
                    >
                      Purchase History
                    </LoadingButton>
                  </Grid>

                  <Grid item xs={12} sm={4} md={6} lg={6}>
                    {hasPermission({ scopes: [SCOPES.canAll] }) ? (
                      <Typography
                        variant="subtitle2"
                        sx={{ ...FileUploadBoxNoteSx, fontSize: "13px" }}
                      >
                        (Note: Once you perform sync operation, you have to
                        select respective checkbox from "Use Data" to apply
                        changes.)
                      </Typography>
                    ) : (
                      <Typography
                        variant="subtitle2"
                        sx={{ ...FileUploadBoxNoteSx, fontSize: "13px" }}
                      >
                        (Note: You can perform sync operation, but only an
                        administrator can apply the changes, so please contact
                        an administrator.)
                      </Typography>
                    )}
                  </Grid>
                </Grid>
                <PermissionsGate scopes={[SCOPES.canAll]}>
                  <Grid container spacing={1} alignItems="center">
                    <Grid item xs={12} sm={4} md={2} lg={2}>
                      Use Data:
                    </Grid>
                    <Grid item xs={12} sm={4} md={2} lg={2}>
                      <FormControlLabel
                        disabled={
                          disableFields ||
                          isInvalidForInventory ||
                          isSSOrderType
                        }
                        control={
                          <Checkbox
                            checked={storeInventory}
                            onChange={handlePurchaseHistoryToggle()}
                          />
                        }
                        label="Store Inventory"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={2} lg={2}>
                      <FormControlLabel
                        disabled={
                          disableFields ||
                          isInvalidForInventory ||
                          isSSOrderType
                        }
                        control={
                          <Checkbox
                            checked={purchaseHistory}
                            onChange={handlePurchaseHistoryToggle(true)}
                          />
                        }
                        label="Purchase History"
                      />
                    </Grid>
                  </Grid>
                </PermissionsGate>
              </Paper>
            </Box>
            <Accordion
              sx={{
                margin: "0px !important",
                marginTop: "12px !important",
                marginBottom: "12px !important",
                border: "none",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="file-upload-content"
                id="file-upload-header"
                sx={{
                  "&.Mui-expanded": {
                    minHeight: "auto !important",
                    ".MuiAccordionSummary-content": {
                      margin: "12px 0px !important",
                    },
                  },
                }}
              >
                <Typography
                  sx={{ fontWeight: "bold", fontSize: 17 }}
                  component="p"
                >
                  Upload/Download Files
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{ fontWeight: "bold", fontSize: 17 }}
                      component="p"
                    >
                      Store Inventory
                    </Typography>
                  </Box>
                  <Paper elevation={0} sx={{ padding: 3, marginY: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Grid item sx={{ mb: 0.5 }}>
                        <Typography
                          variant="subtitle2"
                          sx={FileUploadBoxNoteSx}
                        >
                          Note: Upload a file with .xls, .xlsx or .csv
                          extension.
                        </Typography>
                        <Box sx={TemplateLinkSx}>
                          Template Link:&nbsp;
                          <Link
                            color="inherit"
                            sx={TemplateHyperLink}
                            onClick={downloadSITemplate}
                          >
                            Store Inventory
                          </Link>
                        </Box>
                      </Grid>
                      <Grid item>
                        <FileUpload
                          onUploadFile={handleSIFileUpload}
                          uploading={fileUploading?.storeInv}
                          disabled={
                            disableFields ||
                            isInvalidForInventory ||
                            isSSOrderType
                          }
                          getFileData={(data) => {
                            setSIFileData(data);
                          }}
                        />
                      </Grid>
                    </Box>
                    {siFileDetails.length > 0 && (
                      <FileDetailsTable rows={siFileDetails} />
                    )}
                    {showUploadedSIFile && (
                      <Typography variant="subtitle2" sx={FileSuccessTitleSx}>
                        Successfully Uploaded{" "}
                        <Link href={uploadedSIFileLink} color="inherit">
                          {siFileName}
                        </Link>
                      </Typography>
                    )}
                    {showSIErrorFile && (
                      <Box>
                        <Link href={errorSIFileLink} variant="subtitle2">
                          Download Error File
                        </Link>
                        <Link
                          href={uploadedSIFileLink}
                          variant="subtitle2"
                          ml={2}
                        >
                          Download Uploaded File
                        </Link>
                      </Box>
                    )}
                  </Paper>
                </Box>
                <Divider />
                <Box
                  sx={{ display: "flex", flexDirection: "column" }}
                  marginTop={1}
                >
                  <Typography
                    sx={{ fontWeight: "bold", fontSize: 17 }}
                    component="p"
                  >
                    Dataguide
                  </Typography>
                  <Paper elevation={0} sx={{ padding: 3, marginY: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Grid item sx={{ mb: 0.5 }}>
                        <Typography
                          variant="subtitle2"
                          sx={FileUploadBoxNoteSx}
                        >
                          Note: Upload a file with .xlsx extension.
                        </Typography>
                        <Box sx={TemplateLinkSx}>
                          Download Link:&nbsp;
                          <Link
                            color="inherit"
                            sx={TemplateHyperLink}
                            onClick={downloadDataguide}
                          >
                            Dataguide
                          </Link>
                        </Box>
                      </Grid>
                      <Grid item>
                        <FileUpload
                          onUploadFile={handleDataguideUpload}
                          uploading={fileUploading?.dataguide}
                          disabled={
                            disableFields ||
                            isInvalidForDataguide ||
                            isSSOrderType
                          }
                          getFileData={(data) => {
                            setDataguideData(data);
                          }}
                          isDataguide
                        />
                      </Grid>
                    </Box>
                    {dataguideDetails.length > 0 && (
                      <FileDetailsTable rows={dataguideDetails} isDataguide />
                    )}
                  </Paper>
                </Box>
                <Divider />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  marginTop={1}
                >
                  <Typography
                    sx={{ fontWeight: "bold", fontSize: 17 }}
                    component="p"
                  >
                    OSO Item List
                  </Typography>
                  <Paper elevation={0} sx={{ padding: 3, marginY: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Grid item sx={{ mb: 0.5 }}>
                        <Typography
                          variant="subtitle2"
                          sx={FileUploadBoxNoteSx}
                        >
                          Note: Upload a file with .xlsx extension.
                        </Typography>
                        <Box sx={TemplateLinkSx}>
                          Template Link:&nbsp;
                          <Link
                            color="inherit"
                            sx={TemplateHyperLink}
                            onClick={downloadILTemplate}
                          >
                            OSO Item List
                          </Link>
                        </Box>
                      </Grid>
                      <Grid item>
                        <FileUpload
                          onUploadFile={handleOSOItemListUpload}
                          uploading={fileUploading?.OSOItemList}
                          disabled={
                            disableFields ||
                            isInvalidForDataguide ||
                            isInvalidForInventory ||
                            isSSOrderType
                          }
                          getFileData={(data) => {
                            setILFileData(data);
                          }}
                          isDataguide
                        />
                      </Grid>
                    </Box>
                    {ilFileDetails.length > 0 && (
                      <FileDetailsTable rows={ilFileDetails} isOSOItemList />
                    )}
                    {showUploadedILFile && (
                      <Typography variant="subtitle2" sx={FileSuccessTitleSx}>
                        Successfully Uploaded{" "}
                        <Link href={uploadedILFileLink} color="inherit">
                          {ilFileName}
                        </Link>
                      </Typography>
                    )}
                    {showILErrorFile && (
                      <Box>
                        <Link href={errorILFileLink} variant="subtitle2">
                          Download Error File
                        </Link>
                        <Link
                          href={uploadedILFileLink}
                          variant="subtitle2"
                          ml={2}
                        >
                          Download Uploaded File
                        </Link>
                      </Box>
                    )}
                  </Paper>
                </Box>
                <Divider />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  marginTop={1}
                >
                  <Typography
                    sx={{ fontWeight: "bold", fontSize: 17 }}
                    component="p"
                  >
                    Store Supplies Item List
                  </Typography>
                  <Paper elevation={0} sx={{ padding: 3, marginY: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Grid item sx={{ mb: 0.5 }}>
                        <Typography
                          variant="subtitle2"
                          sx={FileUploadBoxNoteSx}
                        >
                          Note: Upload a file with .xlsx extension.
                        </Typography>
                        <Box sx={TemplateLinkSx}>
                          Template Link:&nbsp;
                          <Link
                            color="inherit"
                            sx={TemplateHyperLink}
                            onClick={downloadSSTemplate}
                          >
                            Store Supplies Item List
                          </Link>
                        </Box>
                      </Grid>
                      <Grid item>
                        <FileUpload
                          onUploadFile={handleSSItemListUpload}
                          uploading={fileUploading?.SSItemList}
                          disabled={
                            disableFields ||
                            isInvalidForDataguide ||
                            isInvalidForInventory
                          }
                          getFileData={(data) => {
                            setSSFileData(data);
                          }}
                          isDataguide
                        />
                      </Grid>
                    </Box>
                    {ssFileDetails.length > 0 && (
                      <FileDetailsTable rows={ssFileDetails} isOSOItemList />
                    )}
                    {showUploadedSSFile && (
                      <Typography variant="subtitle2" sx={FileSuccessTitleSx}>
                        Successfully Uploaded{" "}
                        <Link href={uploadedSSFileLink} color="inherit">
                          {ssFileName}
                        </Link>
                      </Typography>
                    )}
                    {showSSErrorFile && (
                      <Box>
                        <Link href={errorSSFileLink} variant="subtitle2">
                          Download Error File
                        </Link>
                        <Link
                          href={uploadedSSFileLink}
                          variant="subtitle2"
                          ml={2}
                        >
                          Download Uploaded File
                        </Link>
                      </Box>
                    )}
                  </Paper>
                </Box>
              </AccordionDetails>
            </Accordion>
            <Box
              sx={{ display: "flex", flexDirection: "column" }}
              marginTop={1}
            >
              <Typography
                sx={{ fontWeight: "bold", fontSize: 17 }}
                component="p"
              >
                Project Status
              </Typography>
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: 3,
                  marginY: 1,
                }}
              >
                <ProjectStatus
                  statusCode={details?.StatusCode}
                  isPending={Boolean(details?.IsPending)}
                  getProjectStatus={(data) => {
                    setProjStatus(data);
                  }}
                  isProjectPending={(data) => {
                    setPending(data);
                  }}
                  disableActions={disableStatus}
                />
              </Paper>
            </Box>
            <PermissionsGate scopes={[SCOPES.canEdit]}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  py: 2,
                }}
              >
                <Button
                  variant="outlined"
                  sx={{ mx: 3, backgroundColor: "#fff" }}
                  onClick={() => {
                    window.location.reload();
                    window.scroll(0, 0);
                  }}
                  disabled={isProjectArchived}
                >
                  Reset
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  disabled={isProjectArchived}
                >
                  Save
                </Button>
              </Box>
            </PermissionsGate>
          </Container>
          {status === 200 && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={open}
              onClose={handleClose}
            >
              <Snackbar
                autoHideDuration={8000}
                open={open}
                onClose={handleClose}
              >
                <Alert
                  onClose={handleClose}
                  severity="success"
                  sx={{ width: "100%" }}
                >
                  Project is updated Successfully!
                </Alert>
              </Snackbar>
            </Backdrop>
          )}
          {status === 500 && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={open}
              onClose={handleErrorClose}
            >
              <Snackbar
                autoHideDuration={8000}
                open={open}
                onClose={handleErrorClose}
              >
                <Alert
                  onClose={handleErrorClose}
                  severity="error"
                  sx={{ width: "100%" }}
                >
                  Failed to save the changes. Please try again.
                </Alert>
              </Snackbar>
            </Backdrop>
          )}
          {promiseInProgress && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          <CommonDialog
            open={showStoreDialog}
            title="Available Stores"
            maxWidth="xl"
            content={
              isCRMStore ? (
                <StoreDialogContent
                  rows={storeDetails}
                  handleStoreSelection={handleStoreSelection}
                />
              ) : (
                <ModelStoreDialogContent
                  rows={modelStoreDetails}
                  handleStoreSelection={handleStoreSelection}
                />
              )
            }
            type="cancelApply"
            handleClose={handleStoreDialogCancel}
            handleDone={handleStoreDialogDone}
          />
          <CommonDialog
            open={showErrorDialog}
            title={errorTitle}
            maxWidth="sm"
            content={errorContent}
            type="ok"
            handleClose={handleErrorDialogClose}
          />
          <CommonDialog
            open={showConfirmDialog}
            title="Modify with Model Store?"
            maxWidth="sm"
            content={`This store currently has Discount applied. Now you also added a Model Store: ${modelStoreValueWatcher} ${
              (modelStoreDetails &&
                modelStoreDetails[selectedStoreIndex]?.StoreName) ||
              ""
            } to clone. If you add a Model Store, all the previously applied data will be replaced with Model Store data. Are you sure you want to continue?`}
            type="yesNo"
            handleClose={handleConfirmDialogNo}
            handleDone={handleConfirmDialogYes}
          />
          <CommonDialog
            open={showOrderTypeWarningDialog}
            title="Override Store Changes"
            maxWidth="sm"
            content={
              <span>
                Changing order type to <b>Fill In</b> will override current item
                selections/changes after save. Are you sure you want to
                continue?
              </span>
            }
            type="yesNo"
            handleClose={handleOrderTypeDialogNo}
            handleDone={handleOrderTypeDialogYes}
          />
          <CommonDialog
            open={showModelStoreWarningDialog}
            title="Override Store Changes"
            maxWidth="sm"
            content={
              <span>
                Model store will override current item selections/changes after
                save. Are you sure you want to continue?
              </span>
            }
            type="yesNo"
            handleClose={handleModelStoreDialogNo}
            handleDone={handleModelStoreDialogYes}
          />
          <CommonDialog
            open={showSIPHDialog}
            title={
              typeSelected === "PH" ? "Purchase History" : "Store Inventory"
            }
            maxWidth="sm"
            content={
              typeSelected === "PH" ? (
                <>
                  {!purchaseHistory ? (
                    <>
                      <p>
                        This action will apply a Purchase History details. Are
                        you sure, you want to continue?{" "}
                      </p>
                      <p style={DialogNoteSx}>
                        <b>Note:</b> It will use historical data of purchase for
                        inventory, after clicking on "Yes" button.
                      </p>
                    </>
                  ) : (
                    <p>
                      Are you sure, you don't want to consider Purchase History?{" "}
                    </p>
                  )}
                </>
              ) : (
                <>
                  {!storeInventory ? (
                    <p>
                      This action will apply a Store Inventory details. Are you
                      sure, you want to continue?{" "}
                    </p>
                  ) : (
                    <p>
                      Are you sure, you don't want to consider Store Inventory?{" "}
                    </p>
                  )}
                </>
              )
            }
            type="yesNo"
            handleClose={handleSIPHDialogNo}
            handleDone={handleSIPHDialogYes}
          />
          <CommonDialog
            open={showStoreSuppliesWarningDialog}
            title="Override Store Changes"
            maxWidth="sm"
            content={
              <span>
                Store Supplies will override current applied model store changes
                after save. Are you sure you want to continue?
              </span>
            }
            type="yesNo"
            handleClose={handleSSDialogNo}
            handleDone={handleSSDialogYes}
          />
        </form>
      ) : (
        ""
      )}
    </>
  );
}

export default withSnackbar(Details);
